import request from '@/utils/request'

// 分页查询银河打本房间线索图片
export function pageRoomClueImg(query) {
  return request({
    url: '/played/room/clue/relation/pageRoomClueImg',
    method: 'get',
    params: query
  })
}

// 删除银河打本房间线索关联
export function remove(id) {
  return request({
    url: '/played/room/clue/relation/' + id,
    method: 'delete'
  })
}
